import React, { useState, useEffect } from 'react';
import { getOffers } from '../../services/api';

export default function Offers() {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getOffers()
      .then(({ data }) => setOffers(data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>🎁 Exclusive Offers</h1>
        <p style={styles.subtitle}>Special deals just for Blixo players</p>
      </div>

      {loading ? (
        <div style={styles.loading}>Loading offers...</div>
      ) : offers.length === 0 ? (
        <div style={styles.empty}>
          <div style={{ fontSize: '56px', marginBottom: '16px' }}>🎁</div>
          <div style={styles.emptyTitle}>No offers available right now</div>
          <div style={styles.emptySub}>Check back soon for exclusive deals!</div>
        </div>
      ) : (
        <div style={styles.grid}>
          {offers.map(offer => (
            <div key={offer._id} style={styles.card}>
              {offer.imageUrl
                ? <img src={offer.imageUrl} alt={offer.name} style={styles.cardImg} />
                : <div style={styles.cardImgPlaceholder}>🎁</div>
              }
              <div style={styles.cardBadge}>EXCLUSIVE OFFER</div>
              <div style={styles.cardBody}>
                <h2 style={styles.cardTitle}>{offer.name}</h2>
                <p style={styles.cardSub}>{offer.subtitle}</p>
                <p style={styles.cardDesc}>{offer.description}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const styles = {
  container: { flex: 1, overflowY: 'auto', padding: '28px', fontFamily: "'Exo 2', sans-serif" },
  header: { marginBottom: '28px' },
  title: { margin: 0, fontSize: '26px', fontWeight: '700', color: '#e2e8f0', fontFamily: "'Rajdhani', sans-serif", letterSpacing: '1px' },
  subtitle: { margin: '6px 0 0', color: 'rgba(255,255,255,0.3)', fontSize: '14px' },
  loading: { textAlign: 'center', color: 'rgba(255,255,255,0.3)', padding: '60px' },
  empty: { textAlign: 'center', padding: '60px', color: 'rgba(255,255,255,0.25)' },
  emptyTitle: { fontSize: '18px', fontWeight: '600', marginBottom: '8px' },
  emptySub: { fontSize: '14px' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' },
  card: { background: '#0d1420', borderRadius: '18px', border: '1px solid rgba(245,166,35,0.1)', overflow: 'hidden', position: 'relative' },
  cardImg: { width: '100%', height: '170px', objectFit: 'cover', display: 'block' },
  cardImgPlaceholder: { width: '100%', height: '120px', background: 'rgba(245,166,35,0.04)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '48px' },
  cardBadge: { position: 'absolute', top: '12px', left: '12px', background: 'linear-gradient(90deg, #f5a623, #00aaff)', color: '#080c14', fontSize: '9px', fontWeight: '900', letterSpacing: '2px', borderRadius: '6px', padding: '4px 10px' },
  cardBody: { padding: '18px' },
  cardTitle: { margin: '0 0 6px', fontSize: '19px', fontWeight: '700', color: '#e2e8f0', fontFamily: "'Rajdhani', sans-serif" },
  cardSub: { margin: '0 0 10px', color: '#f5a623', fontSize: '13px' },
  cardDesc: { margin: 0, color: 'rgba(255,255,255,0.35)', fontSize: '13px', lineHeight: '1.6' },
};
